// 供销商名称
import { getGoodsFissionRulesApi,goodsFissionConfigApi } from '@/servers/prod/goodsFissionRule.js'

const common = {
  state: () => ({
    goodsFissionRules: [], // ai爆款裂变规则
    goodsFissionCfg:{}, // ai爆款裂变配置
  }),
  mutations: {
    setGoodsFissionRulesList(state, list) {
      state.goodsFissionRules = list;
    },
    setSupportFissionRules(state, data){
      state.isSupportFissionRules = data;
    },
    setGoodsFissionConfig(state, data){
      state.goodsFissionCfg = data;
    }
  },
  actions: {
    getGoodsFissionRules({ commit, state }) {
      let params = {
        pageSize:99999,
        pageNo:1,
      }
      getGoodsFissionRulesApi(params).then(res => {
          if(res){
              commit("setGoodsFissionRulesList", res.records || []);
          }
      }).catch(err => {})
    },
    getGoodsFissionConfig({ commit, state }){
      goodsFissionConfigApi().then(res => {
        if(res){
          commit("setGoodsFissionConfig", res || {});
        }
      })
    },
  },
  getters: {
    goodsFissionRulesList(state){
        return state.goodsFissionRules
    },
    goodsFissionConfig(state){
      return state.goodsFissionCfg
    }
  },
};

export default common;
